import React from 'react';
import { Platform } from 'react-native';
import { Link } from 'expo-router';
import { useAuthStore } from '@/store/auth';
import SidebarListItemLayout from './SidebarListItemLayout';

export default function SidebarRemoteLink({ pathname, navigation, Item, colors, placement = 'main', indentation }) {
  const isMac = Platform.OS === 'macos';
  const visible = useAuthStore(state => !!state.user?.id && !state.user?.flags?.isGhost &&
    (isMac ? placement === 'main' : (state.user?.tracking?.hasUsedMacApp === true) === (placement === 'main')));
  if (!visible || !['ios', 'android', 'macos'].includes(Platform.OS)) return null;
  const title = 'Remote';
  const icon = isMac ? 'mobile-screen' : 'laptop';
  if (navigation && Item) return <Item label={title} icon={icon} colors={colors}
    style={placement === 'more' ? { paddingLeft: 20 } : undefined}
    isActive={pathname === '/remote-projects'} onPress={() => {
      navigation.navigate('remote-projects');
      if (!isMac) navigation.closeDrawer();
    }} />;
  return <Link href="/remote-projects" asChild withAnchor>
    <SidebarListItemLayout id="remote-projects" title={title} icon={icon}
      isActive={pathname === '/remote-projects'} indentation={indentation} noEllipsis />
  </Link>;
}
